var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCandyAlt3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6374 10.3406C19.1984 12.5934 18.5983 15.0759 16.8371 16.8371C15.0759 18.5983 12.5934 19.1984 10.3406 18.6374L9.70955 21.1618C9.50112 21.9955 8.46283 22.2831 7.85515 21.6754L2.32457 16.1449C1.71689 15.5372 2.00448 14.4989 2.83821 14.2904L5.36256 13.6594C4.80163 11.4066 5.40175 8.92406 7.1629 7.1629C8.92406 5.40175 11.4066 4.80163 13.6594 5.36256L14.2904 2.83821C14.4989 2.00448 15.5372 1.71689 16.1449 2.32457L21.6754 7.85515C22.2831 8.46283 21.9955 9.50112 21.1618 9.70955L18.6374 10.3406ZM16.75 11C16.75 10.5858 16.4142 10.25 16 10.25C15.5858 10.25 15.25 10.5858 15.25 11C15.25 13.3472 13.3472 15.25 11 15.25C10.5858 15.25 10.25 15.5858 10.25 16C10.25 16.4142 10.5858 16.75 11 16.75C14.1756 16.75 16.75 14.1756 16.75 11Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandyAlt3);
export default __webpack_public_path__ + "static/media/candy-alt-3.25831d04812ddaf983057c5e6fae6623.svg";
export { ForwardRef as ReactComponent };